import { Grid, FormControl } from "@mui/material";

interface FieldProps {
  children: React.ReactNode;
}

const Field = ({ children }: FieldProps) => (
  <Grid item xs={12} sm={4}>
    <FormControl fullWidth>{children}</FormControl>
  </Grid>
);

export default Field;
